@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Invoice</h1>
            @if(!isReadOnly) {
            <div class="action">
                <ppl-button label="Add New Invoice" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="onNewInvoice()"
                    [authorizeButton]="[pageId, 'AddNewInvoice']"></ppl-button>
            </div>
            }
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-invoice-filter (searchEvent)="onSearch($event)" (exportEvent)="onExport($event)" [filterFields]="filterFields" [chequeNumbers]="chequeNumbers" [export]="true" [pageId]="pageId"></ppl-invoice-filter>
                    <p class="pl-2"> <span class="error-message">*</span> Atleast one out of the following fields should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>, <b>Provider PPL ID</b>.</p>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [enableActions]="true" [data]="invoices" (rowDetailEvent)="rowClicked($event)"
                        (rowDetailEventTs)="onRowActions($event)" [disableSelection]="true" [cols]="cols"
                        (gridAction)="onAction($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true"
                        [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)" [showExpandIcon]="true"
                        [actionButtons]="actionButtons" [showLineItem]="true" [lineItemCols]="lineItemCols"
                        [from]="'invoices'" [actionsToBeHidden]="actionsToBeHidden"
                        [columnsToBeHidden]="columnsToBeHidden" [cellClassResolver]="serviceDatesCellClassResolver">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name, Provider PPL ID</p>
    </ng-template>
</div>

<div class="filter-panel">
  <ng-template #addInvoiceDialog let-cancel="cancel">
    <ppl-add-invoice [mode]="mode" [invoiceId]="invoiceId" [providerId]="selectedLineItem?.providerId" [consumerId]="selectedLineItem?.consumerId"
      (invoiceSaved)="handleCancel($event)" (cancel)="handleCancel($event)" [staffView]="true" [isReadOnly]="isReadOnly"></ppl-add-invoice>
  </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>
